import { goToTime } from 'Actions/adStateActions';
import { exitTextEditMode } from 'Actions/UIActions';
import { getActiveGroup, getKeyframes, getSelectedAdstate, makeGetComponentByKey } from '../selectors';
import { batchActions } from '../reducers/batchReducer';


export const selectKeyframe = (keyframe, component, append) => ({
  type: 'SELECT_KEYFRAME',
  keyframe,
  component,
  append,
});

export const selectAndGoToKeyframe = (keyframe, component, append) => (dispatch) => {
  dispatch(batchActions([selectKeyframe(keyframe, component, append), goToTime(keyframe.t)]));
};

export const deselectKeyframe = keyframe => ({
  type: 'DESELECT_KEYFRAME',
  keyframe,
});

export const deselectAllKeyframes = () => ({
  type: 'DESELECT_ALL_KEYFRAMES',
});

export const selectComponent = (component, adStateKey, append) => ({
  type: 'SELECT_COMPONENT',
  component,
  adStateKey,
  append,
});

export const selectComponentByKey = ({ componentKey, append = false }) => {
  const getComponentByKey = makeGetComponentByKey();
  return (dispatch, getState) => {
    const state = getState();
    const adStateKey = getSelectedAdstate(state).key;
    const component = getComponentByKey(state, { componentKey });
    dispatch(selectComponent(component, adStateKey, append));
  };
};

export const activateGroup = ({ componentKey }) => ({
  type: 'ACTIVATE_GROUP',
  componentKey,
});

export const selectComponentIfNotTextEditMode =
  (component, adStateKey, append) => (dispatch, getState) => {
    if (getState().getIn(['fonts', 'textEditMode'])) {
      dispatch(exitTextEditMode());
    } else {
      dispatch(selectComponent(component, adStateKey, append));
    }
  };

export const deselectComponents = (shouldDeselectGroup = false) => (dispatch, getState) => {
  if (!getState().getIn(['fonts', 'textEditMode'])) {
    dispatch({
      type: 'DESELECT_COMPONENTS',
      shouldDeselectGroup,
    });
  }
};

export const deselectComponent = ({ component }) => (dispatch, getState) => {
  if (!getState().getIn(['fonts', 'textEditMode'])) {
    dispatch({ type: 'DESELECT_COMPONENT', component });
  }
};

export const shouldDeselectComponent = (state, component) => {
  const selectedKeyframes = component
    .keyframes
    .toSeq()
    .map(mId => getKeyframes(state).get(mId))
    .filter(k => k.selected);

  return (selectedKeyframes.count() === 1);
};

export const deselectKeyframeAndMaybeComponent = ({ keyframe, component }) => (dispatch, getState) => {
  if (shouldDeselectComponent(getState(), component)) {
    dispatch(deselectComponent({ component }));
  }

  dispatch(deselectKeyframe(keyframe));
};

export const deselectAdState = () => (dispatch, getState) => {
  if (!getState().getIn(['fonts', 'textEditMode'])) {
    dispatch(deselectComponents());
    dispatch(deactivateGroup());
    dispatch({
      type: 'DESELECT_ADSTATE',
    });
  }
};

export const selectAdStateIfNotTextEditMode = adState => (dispatch, getState) => {
  if (getState().getIn(['fonts', 'textEditMode'])) {
    dispatch(exitTextEditMode());
  } else {
    dispatch(deselectAdState());
    dispatch(deselectComponents());
    dispatch({
      type: 'SELECT_ADSTATE',
      adState,
    });
  }
};

export const selectAdState = adState => (dispatch) => {
  dispatch(deselectAdState());
  dispatch(deselectComponents(true));
  dispatch({
    type: 'SELECT_ADSTATE',
    adState,
  });
};

export const selectComponentKeyframes = (component, append) => ({
  type: 'SELECT_COMPONENT_KEYFRAMES',
  component,
  append,
});

export const hoverComponent = component => ({
  type: 'HOVER_COMPONENT',
  component,
});

export const unhoverComponent = component => ({
  type: 'UNHOVER_COMPONENT',
  component,
});

export const batchSelectKeyframes = (keyframeKeys, append) => ({
  type: 'BATCH_SELECT_KEYFRAMES',
  keyframeKeys,
  append,
});

export const batchSelectComponents = (componentKeys, adState, append) => ({
  type: 'BATCH_SELECT_COMPONENTS',
  componentKeys,
  adState,
  append,
});

export const selectAllComponents = () => (dispatch, getState) => {
  const adState = getSelectedAdstate(getState());
  const activeGroup = getActiveGroup(getState());
  const components = activeGroup ? activeGroup.subComponents : adState.components;
  if (getState().getIn(['fonts', 'textEditMode'])) return;
  if (adState.key === '') return;
  dispatch(
    batchActions([
      deselectComponents(),
      batchSelectComponents(components, adState),
    ]),
  );
};

export const deactivateGroup = () => ({
  type: 'DEACTIVATE_GROUP',
});

export const closeGroup = () => ({
  type: 'CLOSE_GROUP',
});



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/actions/selectionActions.js